import Component from 'gia/Component';

export default class Review extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      review: {},
      moreButton: {},
    };
  }

  mount() {
    let that = this;
    this.ref.moreButton.addEventListener('click', function() {
      that.ref.review.classList.toggle('line-clamp-4');
      that.ref.moreButton.textContent = !that.ref.review.classList.contains('line-clamp-4') ? 'Show less' : 'Show more';
    });
  }

}